module.exports = __webpack_public_path__ + "img/superLogo.1a83bc8c.svg";